import { supabase } from '@/lib/supabase';
import { ROOM_JOIN, stripRoomJoin } from '@/lib/data/room-scoped';
import type { Database, ScheduleEntryRow } from '@/types/database';

type ScheduleInsert = Database['public']['Tables']['schedule_entries']['Insert'];
type ScheduleUpdate = Database['public']['Tables']['schedule_entries']['Update'];

export async function listScheduleForProject(projectId: string): Promise<ScheduleEntryRow[]> {
  // One request, scoped through the room — see @/lib/data/room-scoped.
  const { data, error } = await supabase
    .from('schedule_entries').select(`*, ${ROOM_JOIN}`)
    .eq('rooms.project_id', projectId)
    .order('start_date', { ascending: true, nullsFirst: false })
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return stripRoomJoin<ScheduleEntryRow>(data);
}

export async function listSchedule(roomId: string): Promise<ScheduleEntryRow[]> {
  const { data, error } = await supabase
    .from('schedule_entries')
    .select('*')
    .eq('room_id', roomId)
    .order('start_date', { ascending: true, nullsFirst: false })
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createSchedule(input: ScheduleInsert): Promise<ScheduleEntryRow> {
  const { data, error } = await supabase.from('schedule_entries').insert(input).select().single();
  if (error) throw error;
  return data;
}

export async function updateSchedule(id: string, patch: ScheduleUpdate): Promise<ScheduleEntryRow> {
  const { data, error } = await supabase.from('schedule_entries').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function deleteSchedule(id: string): Promise<void> {
  const { error } = await supabase.from('schedule_entries').delete().eq('id', id);
  if (error) throw error;
}
